/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import {
  QuoteDisplayAmount,
  StoreConfigModel,
} from '@/quote-management/data/models';
import { State } from '@/quote-management/types/state.types';

export const DEFAULT_PERMISSIONS = {
  requestQuote: false,
  editQuote: false,
  deleteQuote: false,
  checkoutQuote: false,
  viewQuoteTemplates: false,
  manageQuoteTemplates: false,
  generateQuoteFromTemplate: false,
};

export const DEFAULT_CONFIG: StoreConfigModel = {
  quoteSummaryDisplayTotal: 1,
  quoteSummaryMaxItems: 10,
  quoteDisplaySettings: {
    zeroTax: false,
    subtotal: QuoteDisplayAmount.TAX_INCLUDED,
    price: QuoteDisplayAmount.TAX_INCLUDED,
    shipping: QuoteDisplayAmount.TAX_INCLUDED,
    fullSummary: false,
    grandTotal: true,
  },
  useConfigurableParentThumbnail: true,
  quoteMinimumAmount: null,
  quoteMinimumAmountMessage: null,
};

const _state: State = {
  authenticated: false,
  permissions: DEFAULT_PERMISSIONS,
  config: DEFAULT_CONFIG,
  initialized: false,
  quoteDataLoaded: false,
  quoteDataInitialized: false,
};

// Proxy state to make it reactive
export const state = new Proxy(_state, {
  get: (target, key) => {
    return target[key as keyof State];
  },
  set: (target, key, value) => {
    target[key as keyof State] = value;
    return true;
  },
});
